import React from 'react';

import UsefulLinkIcon from '../../../assets/Link.png';
import { RightOutlined } from '@ant-design/icons';

interface IResourcesSectionProps {
  settings: any;
}

const ResourcesSection: React.FunctionComponent<IResourcesSectionProps> = ({
  settings,
}) => (
  <div className="resources-section">
    {Object.keys(settings?.resources).map((itm: any) => (
      <div key={itm} className="section-container">
        <div className="resources-section-label">
          <img src={UsefulLinkIcon} alt="" />
          {itm}
        </div>
        <div className="resources-links">
          {settings?.resources[itm].map((resource: any, idx: number) => (
            <a
              href={resource.link}
              key={idx}
              className="resources-link"
              target="_blank"
              rel="noreferrer"
            >
              {resource.name} <RightOutlined />
            </a>
          ))}
        </div>
      </div>
    ))}
  </div>
);
export default ResourcesSection;
